import { render, staticRenderFns } from "./ddwc.vue?vue&type=template&id=03bb11e9&scoped=true&"
import script from "./ddwc.vue?vue&type=script&lang=js&"
export * from "./ddwc.vue?vue&type=script&lang=js&"
import style0 from "./ddwc.vue?vue&type=style&index=0&id=03bb11e9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bb11e9",
  null
  
)

export default component.exports